module.exports = __webpack_public_path__ + "static/img/this is my schl.686ba2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/this is my schl.png
// module id = jBgn
// module chunks = 1